import Vue from 'vue'
// import VueRouter from 'vue-router'
// import { routes } from './router/index'
import { store } from './store/store'

import { Message } from 'element-ui'
import VueClipboard from 'vue-clipboard2'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import App from './App.vue'

// import style
// import 'swiper/dist/css/swiper.min.css'
import '@/styles/reset.css'

Vue.config.productionTip = false

Message.install = function(Vue) {
  Vue.prototype.$message = Message
}

// Vue.use(VueRouter)
Vue.use(VueClipboard)
Vue.use(Message) //消息提示
// Vue.use(VueAwesomeSwiper)

// const router = new VueRouter({
//   mode: 'history',
//   base: '/ti10Event/',
//   routes,
// })

new Vue({
  // router,
  store,
  render: h => h(App),
}).$mount('#app')
